export function parseTime(time: string) {
    // Converting time to Date to compare minTime and maxTime, because here we are supporting 12 and 24 hours format.
    // to parse the time we need to create date object. So, to create date object we are using hardcoded date along with some choosen time.

    return new Date(`1/1/2019 ${time}`);
}
